import "../css/Login.css";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import { createRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputMask } from "primereact/inputmask";
import { Toast } from "primereact/toast";
import CryptoJS from 'crypto-js';
import { apiClient } from "../apiClient";
import { useOnlineStatus } from "../context/OnlineContext";
import colors from '../colors';


function Login() {


  const [loginError,setLoginError]= useState("");
  const navigate = useNavigate();
  const toast = createRef();
  const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
  const [user,setUser] = useState();
  const config = {headers: { "Content-Type": "application/json" }};
  const { online, setOnline } = useOnlineStatus();

 

   const encryptData = (message) => {
      const secretKey = process.env.REACT_APP_ACCESS_JWT_SECRET;
    
      if (!secretKey) {
          throw new Error("Encryption key is missing!");
      }
  
      // 🔹 Ensure key is 32 bytes
      const key = CryptoJS.enc.Utf8.parse(secretKey.padEnd(32, ' '));
  
      const encrypted = CryptoJS.AES.encrypt(message, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
      }).toString();
  
      return encrypted;
  };
  

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validate: (values) => {
      let errors = {};

      if (!values.username) {
        errors.username = "لطفا شماره موبایل را وارد کنید";
      }

      if (!values.password) {
        errors.password = "لطفاً رمز عبور را وارد کنید";
      }

      return errors;
    },

    onSubmit: (values) => {

      
      

      const data = JSON.stringify({
        username: values.username,
        password: values.password,
        adminUsername:""
      });

     
     



      apiClient.post(process.env.REACT_APP_BACK+"/users/login", data, config)
        .then((response) => {
          if (response.status == 201)
          {

            //user can login:
            const user = response.data.User;

   


            if(user.role === "manager")
              navigate("/manager-dashboard");
            else
              navigate("/dashboard",  { state: { user: user}});

            //cache user:
            localStorage.setItem("seo_app", JSON.stringify(user));
            localStorage.setItem("userToken", JSON.stringify(response.data.token));

            // Set online status to true
            setOnline(true);
            

            //set user theme:
            // props.setTheme(getUserTheme(user));


          }
          
        })
        .catch((error) => {
          
          setLoginError("اطلاعات ورود اشتباه است");
          

        });


      
     
    },
  });

  const isFormFieldValid = (phone) =>
    !!(formik.touched[phone] && formik.errors[phone]);
  const getFormErrorMessage = (phone) => {
    return (
      isFormFieldValid(phone) && (
        <small className="p-error">{formik.errors[phone]}</small>
      )
    );
  };

  

  return (
    <div id="login-form">


      <Toast ref={toast } style={{background:"red", color:"#ffffff", zIndex:"10000", margin:"0px"}} life="3000" position="center center"/>
      

      <form onSubmit={formik.handleSubmit} style={{textAlign:'right'}}>
        <ul className="add_product_field">
          <li className="label">
            <label htmlFor="username"> شماره موبایل:</label>
          </li>
          <li>
            {" "}
            <InputText
              id="username"
              name="username"
              value={formik.values.username}
              onChange={formik.handleChange}
              className={classNames({
                "p-invalid": isFormFieldValid("username"),
              })}
            />
            {getFormErrorMessage("username")}
          </li>
        </ul>

        <div>
          <ul className="add_product_field">
            <li className="label">
              <label htmlFor="password">رمز عبور:</label>
            </li>
            <li>
              {" "}
              <Password
                inputId="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                toggleMask
                feedback={false}
                className={classNames({
                  "p-invalid": isFormFieldValid("password"),
                })}
              />
              {getFormErrorMessage("password")}
              {loginError!="" ? <small className="p-error">{loginError}</small> : null }
              
            </li>
          </ul>
        </div>

        <div>
          <Button type="submit" className="login-dialog filled-button" label="ورود" />
        </div>

        </form>

     
      
    </div>
  );
}

export default Login;
